import '../css/NoMatch.css';
import SearchIcon from '@material-ui/icons/Search';
import {useHistory} from "react-router-dom";

export default function NoMatch404() {

    const history      = useHistory();
    const goToHomePage =  () => {
        history.push('/dashboard');
    };

    return (
        <div className="no-match">
            <div className="logo">
                <a href="/">
                    <img src="/roobeek_marchio.svg" alt="Roobeek®" title="Roobeek®" style={{width: 130}}/>
                </a>
            </div>

            <div className="container">

                <div className="four-oh-four"><h1><SearchIcon />&nbsp;Page not found</h1></div>

                <div className="warning">
                    <p>
                        The page you are looking for might have been removed, had its name changed, or is temporarily
                        unavailable.
                    </p>
                </div>

                <div className="back">
                    <span onClick={goToHomePage}>Return to the home page</span>
                </div>

            </div>

        </div>
    );
}